import React from "react";
import Markup from "./jsx";
import "./css/style.css";

const App = () => {
  return <Markup />;
};

export default App;